import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import snakeCaseKeys from 'snakecase-keys';
import camelCaseRecursive from 'camelcase-keys-recursive';

import { SimpleCenteredModal } from '../../components';
import { updateOtherRequestTypeRequest } from '../../requests/otherRequestTypes';
import { sendAlert } from '../../actions/utils';
import { delayMethod } from '../../services/utils';
import OtherRequestTypeForm from './OtherRequestTypeForm';
import OtherRequestTypeDataTable from './OtherRequestTypeDataTable';
import OtherRequestTypeShow from './OtherRequestTypeShow';

const OtherRequestTypeIndex = ({ moreData, setMoreData }) => {
  const [modalTitle, setModalTitle] = useState('Nuevo Tipo de Otras Solicitudes');
  const [modalShow, setModalShow] = useState(false);
  const [modalBody, setModalBody] = useState({});
  const dispatch = useDispatch();

  const handleFailureRequest = error => {
    const { response } = error;
    dispatch(sendAlert({ kind: 'error', message: response?.data?.message }));
  };

  const handleUpdate = otherRequestTypeValue => {
    const {
      otherRequestType: { id }
    } = otherRequestTypeValue;
    updateOtherRequestTypeRequest(id, {
      dispatch,
      params: snakeCaseKeys(otherRequestTypeValue),
      formData: true,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Tipo de solicitud actualizado con éxito' }));
        setModalShow(false);
        setMoreData(!moreData);
      },
      failureCallback: handleFailureRequest
    });
  };

  const editOtherRequestType = otherRequestTypeRow => {
    setModalShow(true);
    setModalBody(
      <OtherRequestTypeForm
        otherRequestType={camelCaseRecursive(otherRequestTypeRow)}
        action="edit"
        formRequest={handleUpdate}
        cancelAction={() => delayMethod(() => setModalShow(false))}
      />
    );
    setModalTitle('Editar tipo de solicitud');
  };

  const showOtherRequestType = otherRequestTypeRow => {
    setModalShow(true);
    setModalBody(<OtherRequestTypeShow otherRequestType={camelCaseRecursive(otherRequestTypeRow)} hideModal={() => setModalShow(false)} />);
    setModalTitle(otherRequestTypeRow.name);
  };

  return (
    <>
      <OtherRequestTypeDataTable
        editOtherRequestType={editOtherRequestType}
        moreData={moreData}
        setMoreData={setMoreData}
        showOtherRequestType={showOtherRequestType}
        withMassActions
      />
      <SimpleCenteredModal title={modalTitle} body={modalBody} show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};

export default OtherRequestTypeIndex;